import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Junta classes condicionais e resolve conflitos do Tailwind: a classe de quem USA o componente
 * vence a da base (`w-36` passado a um campo sobrepõe o `w-full` do estilo padrão). Sem o merge,
 * quem vence é a ordem no CSS gerado — e o ajuste some em silêncio.
 */
// Raios e medidas próprios do tema (src/ui/tokens/theme.css) entram no mesmo grupo dos padrões:
// sem isso `h-controle` e `h-controle-sm` convivem e quem vence é a ordem do CSS.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      radius: ['mini', 'controle', 'cartao', 'painel', 'pilula'],
      spacing: [
        'controle',
        'controle-sm',
        'linha',
        'barra',
        'barra-recolhida',
        'gaveta',
        'dialogo',
        'dialogo-largo',
      ],
    },
  },
});

export function cx(...valores: ClassValue[]): string {
  return twMerge(clsx(valores));
}
